// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-nav-menu[data-v-3c1ef684] {\n  border-bottom-width: 0 !important;\n}\n@media screen and (max-width: 767px) {\n.page-content-lightestblue__container[data-v-3c1ef684] {\n      width: 100%\n}\n.page-content-lightestblue__container h2[data-v-3c1ef684] {\n        margin-left: 1rem;\n}\n}\n.amountLimitMessage[data-v-3c1ef684] {\n  font-weight: 600;\n  color: #0046AA;\n  font-family: inherit;\n}\n", ""]);
// Exports
module.exports = exports;
